import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientNewMedicalNoteWarningPopupProps } from "./NewMedicalNoteWarningPopup";

{ /** this shit is to pop an error message when a user without any speciality tries to create a note **/ }
class NewMedicalNoteNoSpecialityWarningPopup extends React.Component<IPatientNewMedicalNoteWarningPopupProps, any> {
    private id: string = "newnotenospecialitypopupmenu";

    public componentDidMount(): void {
        overlayStore.showOverlay(this.id);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.id);
    }

    public render(): JSX.Element {
        return (
            <Popup
                Id={this.id}
                title={cacheStore.GetString("AddNoteLabel")}
                closeTarget={LocalPatientOperations.MedicalSummary.NewNoteNoSpecialityWarningOK}
                draggable={true}
                width={550}
                centeredHorizontally={true}
            >
                <div className="p-body">
                    <div>
                        <span> {cacheStore.GetString("NoteErrorNoServiceLabel")} </span>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button className="btn btn-primary" onClick={this.OkClick.bind(this)}>{cacheStore.GetString("OKLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private OkClick(): void {
        var operation = new LocalEvent(LocalPatientOperations.MedicalSummary.NewNoteNoSpecialityWarningOK);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { NewMedicalNoteNoSpecialityWarningPopup };
